import { ACTION } from './vrf_outdoor_actions';
import makeCrudReducer from './make_crud_reducer';

export default makeCrudReducer(ACTION);



// WEBPACK FOOTER //
// ./src/redux/vrf/vrf_outdoor_reducer.js